export default function receiveLineItem(state = {}, action) {
  switch (action.type) {
    case 'RECEIVE_LINE_ITEM':
      return {
        ...state,
        newlyCreatedLineItem: action.payload,
      }
    default:
      return state
  }
}
